import {  getRequest, putRequest } from '..';

export function get() {
  return getRequest(`/organizationsettings/`);
}

export function edit(settings) {
  return putRequest(`/organizationsettings/`, settings)
}